// Create and setup your form here
 
<template>
  <div>
    <header class="vff-header">
      <div class="f-container">
       <!-- Add custom logo here -->
        <div class ='f-logo'></div>
      </div>
    </header>

    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-on:submit="onSubmit"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="true"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
     <template v-slot:complete>
        <div class="f-section-wrap">
          <p>
            <span class="fh2">Thank you. 🙏</span>
            <span class="f-section-text">
              Great work – we can now calculate your annual carbon footprint! You can review your answers or press submit to find out what your annual carbon footprint looks like!
            </span>
          </p>
        </div>  
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit" v-if="!submitted">
          <button 
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Press to submit"
          >
            <span>{{ language.submitText }}</span>
          </button>
          <a class="f-enter-desc"
            href="#"
            v-on:click.prevent="onSendData()"
            v-html="language.formatString(language.pressEnter)">
          </a>
        </div>

        <p class="text-success" v-if="submitted"> <hr><br>Submitted succesfully.</p>
        <p class="text-success" v-if="submitted">Your calculated carbon footprint is {{carbon_footprint['carbon_footprint']}} <i>tonnes CO<sub>2</sub>/year</i>.</p>

        <p class="text-success" v-if="submitted">Average carbon emission per capita in Mongolia is 26.98 tonnes by 2020.</p>
        <p class="text-success" v-if="submitted">Average carbon emission per capita in United States is 14.24 tonnes by 2020.</p>
        <p class="text-success" v-if="submitted">Average carbon emission per capita in China is 7.41 tonnes by 2020.</p>
        <iframe src="https://ourworldindata.org/grapher/co-emissions-per-capita?tab=chart&country=~MNG" loading="lazy" style="width: 100%; height: 600px; border: 0px none;" v-if="submitted"></iframe>
      </template>
    </flow-form>
  </div>
</template>

<script>
  /*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://www.ditdot.hr/en
  */

  // Import necessary components and classes
  import FlowForm from '../../src/components/FlowForm.vue'
  import QuestionModel, { QuestionType, ChoiceOption, LinkOption } from '../../src/models/QuestionModel'
  import LanguageModel from '../../src/models/LanguageModel'
  // If using the npm package, use the following line instead of the ones above.
  // import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LanguageModel } from '@ditdot-dev/vue-flow-form'
  // Example POST method implementation:
  async function postData(url = '', data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: 'omit', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      //redirect: 'follow', // manual, *follow, error
      //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
  return response.json() // parses JSON response into native JavaScript objects
}
  export default {
    name: 'carbon_calculator',

    components: {
      FlowForm
    },

    data() {
      return {
        submitted: false,
        completed: false,
        language: new LanguageModel(),
        // Create question list with QuestionModel instances
        questions: [
          new QuestionModel({
            id: 'first_name',
            tagline: "Hi! Let's calculate our impact on the environment",
            title: 'What is your first name?',
            type: QuestionType.Text,
            required: true,
            placeholder: 'Start typing here...'
          }),
          new QuestionModel({
            id: 'email',
            tagline: "Nice to meet you 👀, let's continue",
            title: 'Provide your email.',
            type: QuestionType.Email,
            required: true,
            placeholder: 'Start typing here...'
          }),
          new QuestionModel({
            id: 'Energy_housebill',
            title: "How much is your usual monthly electricity bill?",
            tagline: 'Please select the range of your bill.',
            type: QuestionType.MultipleChoice,
            //multiple: true,
            //helpText: 'Select all that apply. 👇',
            required: true,
            options: [
              new ChoiceOption({
                label: '0₮-20,000₮'
              }),
              new ChoiceOption({
                label: '20,000₮-40,000₮'
              }),
              new ChoiceOption({
                label: '60,000₮-80,000₮'
              }),
              new ChoiceOption({
                label: '80,000₮-100,000₮+'
              })
            ]
          }),
          new QuestionModel({
            id: 'Energy_RE',
            title: "Where do you get your electricity from?",
            tagline: 'Please select the answer',
            type: QuestionType.MultipleChoice,
            required: true,
            options:[
            new ChoiceOption({
                label: 'I don\'t know'
              }),
              new ChoiceOption({
                label: 'Electricity Grid'
              }),
              new ChoiceOption({
                label: 'Fully off-grid renewable energy'
              }),
              new ChoiceOption({
                label: 'Hybrid - renewable energy and grid'
              })
            ]
          }),
          new QuestionModel({
            id: 'Energy_heating',
            title: "How do you heat your home?",
            tagline: 'Please select the answer',
            type: QuestionType.MultipleChoice,
            required: true,
            options:[
            new ChoiceOption({
                label: 'District Heating'
              }),
              new ChoiceOption({
                label: 'Coal Stove'
              }),
              new ChoiceOption({
                label: 'Electric Heating'
              })
            ]
          }),
          new QuestionModel({
            id: 'travel_abroad',
            title: "Have you travelled abroad last year?",
            tagline: 'Please select the answer',
            type: QuestionType.MultipleChoice,
            required: true,
            options:[
            new ChoiceOption({
                label: 'Asia'
              }),
              new ChoiceOption({
                label: 'Europe'
              }),
              new ChoiceOption({
                label: 'North America'
              }),
              new ChoiceOption({
                label: 'Other'
              }),
              new ChoiceOption({
                label: "I didn't travel last year"
              })
            ]
          }),
          new QuestionModel({
            id: 'walk',
            title: 'On a scale of 1 to 5 how often do you walk to work per week?',
            subtitle: 'Select the number from 1 to 5',
            type: QuestionType.OpinionScale,
            required: true,
            max: 5,
            labelLeft: 'Never',
            labelRight: 'Always'
          }),
          new QuestionModel({
            id: 'bike',
            title: 'On a scale of 1 to 5 how often do you bike to work per week?',
            subtitle: 'Select the number from 1 to 5',
            type: QuestionType.OpinionScale,
            required: true,
            max: 5,
            labelLeft: 'Never',
            labelRight: 'Always'
          }),
          new QuestionModel({
            id: 'bus',
            title: 'On a scale of 1 to 5 how often do you take a public transportation to work per week?',
            subtitle: 'Select the number from 1 to 5',
            type: QuestionType.OpinionScale,
            required: true,
            max: 5,
            labelLeft: 'Never',
            labelRight: 'Always'
          }),
          new QuestionModel({
            id: 'car',
            title: 'On a scale of 1 to 5 how often do you use car/taxi to work per week?',
            subtitle: 'Select the number from 1 to 5',
            type: QuestionType.OpinionScale,
            required: true,
            max: 5,
            labelLeft: 'Never',
            labelRight: 'Always'
          }),
          new QuestionModel({
            id: 'consumption',
            tagline: "If it is okay, please share your spending amount",
            title: 'How much do you spend buying things per month?',
            type: QuestionType.Number,
            required: false,
            placeholder: '1,568,733₮'
          }),
          new QuestionModel({
            id: 'beef',
            tagline: "Please enter the number of times on average",
            title: 'How many times do you eat a meal with beef per day?',
            type: QuestionType.Number,
            required: true,
            placeholder: '1.5'
          }),
          new QuestionModel({
            id: 'lamb',
            tagline: "Please enter the number of times on average",
            title: 'How many times do you eat a meal with lamb per day?',
            type: QuestionType.Number,
            required: true,
            placeholder: '2'
          }),
          new QuestionModel({
            id: 'chicken',
            tagline: "Please enter the number of times on average",
            title: 'How many times do you eat a meal with chicken per day?',
            type: QuestionType.Number,
            required: true,
            placeholder: '1'
          }),
          new QuestionModel({
            id: 'recycle',
            title: 'Do you recycle your waste?',
            type: QuestionType.MultipleChoice,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Yes'
              }),
              new ChoiceOption({
                label: 'No'
              })
            ]
          })
        ]
      }
    },

    mounted() {
      document.addEventListener('keyup', this.onKeyListener)
    },

    beforeUnmount() {
      document.removeEventListener('keyup', this.onKeyListener)
    },

    methods: {
      onKeyListener($event) {
        // We've overriden the default "complete" slot so
        // we need to implement the "keyup" listener manually.

        if ($event.key === 'Enter' && this.completed && !this.submitted) {
          this.onSendData()
        }
      },

      /* eslint-disable-next-line no-unused-vars */
      onComplete(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
        this.completed = completed
      },

      /* eslint-disable-next-line no-unused-vars */
      onSubmit(questionList) {
        // This method will only be called if you don't override the
        // completeButton slot.
        this.onSendData()
      },

      setCarbonValues(value){
        this.carbon_footprint = value
      },

      
      
      async onSendData() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform.submitted = true

        
        

        /* eslint-disable-next-line no-unused-vars */
        const data = this.getData()
        console.log(JSON.stringify(data))

        
        this.carbon_footprint = await postData(process.env.VUE_APP_SEND_URL, data)
        
        this.submitted = true
        
        

        
        
        
      },

      getData() {
        const data = {
          questions: [],
          answers: [],
          dictionary : null
        }

        this.questions.forEach(question => {
          if (question.title) {
            let answer = question.answer
            if (Array.isArray(answer)) {
              answer = answer.join(', ')
            }

            data.questions.push(question.id)
            data.answers.push(answer)
          }
        })
        let a = data.questions
        let b = data.answers
        data.dictionary = {}
        a.forEach((key, i) => data.dictionary[key] = b[i]);

        return data.dictionary
      }
    }
  }
</script>

<style lang="css">
  @import '../../src/assets/css/themes/theme-minimal.css';
  /* If using the npm package, use the following lines instead of the one above */
  /* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'; */
  /* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css'; */
</style>